
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const navigate = useNavigate();

  const dashboardItems = [
    {
      title: 'Automaten',
      description: 'Automaten verwalten',
      icon: 'ri-robot-line',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      path: '/automaten'
    },
    {
      title: 'Wartung & Service',
      description: 'Service-Übersicht',
      icon: 'ri-tools-line',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      path: '/wartung'
    },
    {
      title: 'Verkauf',
      description: 'Verkäufe erfassen',
      icon: 'ri-shopping-cart-line',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      path: '/verkauf'
    },
    {
      title: 'Lager',
      description: 'Bestände verwalten',
      icon: 'ri-box-3-line',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      path: '/lager'
    },
    {
      title: 'Finanzen',
      description: 'Gewinn & Verlust',
      icon: 'ri-line-chart-line',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      path: '/finanzen'
    },
    {
      title: 'Verträge',
      description: 'Vertragsverwaltung',
      icon: 'ri-file-text-line',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      path: '/vertraege'
    },
    {
      title: 'Investitionen',
      description: 'Abschreibungen',
      icon: 'ri-funds-line',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      path: '/investitionen'
    },
    {
      title: 'Kontakte',
      description: 'Lieferanten',
      icon: 'ri-contacts-line',
      iconBg: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
      path: '/kontakte'
    },
    {
      title: 'Passwörter',
      description: 'Sichere Verwaltung',
      icon: 'ri-lock-line',
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      path: '/passwoerter'
    },
    {
      title: 'Dokumente',
      description: 'Verträge & Unterlagen',
      icon: 'ri-file-list-3-line',
      iconBg: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      path: '/dokumente'
    },
    {
      title: 'Referenzen',
      description: 'Preise & Kosten',
      icon: 'ri-bookmark-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      path: '/referenzen'
    },
    {
      title: 'Vorlagen',
      description: 'Persönliche Vorlagen',
      icon: 'ri-file-word-line',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      path: '/vorlagen'
    },
    {
      title: 'Kalender',
      description: 'Wartung & Termine',
      icon: 'ri-calendar-line',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      path: '/kalender'
    },
    {
      title: 'Projekte',
      description: 'Business-Ideen',
      icon: 'ri-lightbulb-line',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      path: '/projekte'
    },
    {
      title: 'Generator',
      description: 'Rechnungen erstellen',
      icon: 'ri-file-pdf-line',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      path: '/generator'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 w-full overflow-x-hidden">
      <main className="w-full overflow-x-hidden">
        <div className="w-full max-w-full p-2 sm:p-4 lg:p-8">
          <div className="mb-3 sm:mb-6 lg:mb-8">
            <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">
              Dashboard
            </h2>
            <p className="text-xs sm:text-base text-gray-600">
              Blitzschnelle Automaten-Verwaltung
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-4 lg:gap-6 mb-4 sm:mb-6 w-full">
            {dashboardItems.map((item, index) => (
              <div
                key={index}
                onClick={() => navigate(item.path)}
                className="bg-white p-3 sm:p-5 lg:p-6 rounded-lg shadow hover:shadow-md transition-shadow cursor-pointer touch-manipulation w-full overflow-hidden"
              >
                <div className="flex items-center w-full">
                  <div className={`${item.iconBg} p-1.5 sm:p-3 rounded-lg mr-2 sm:mr-4 flex-shrink-0`}>
                    <i className={`${item.icon} text-sm sm:text-xl lg:text-2xl ${item.iconColor} w-3 h-3 sm:w-5 sm:h-5 lg:w-6 lg:h-6 flex items-center justify-center`}></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-xs sm:text-base lg:text-lg font-semibold text-gray-900 mb-0.5 sm:mb-1 truncate">
                      {item.title}
                    </h3>
                    <p className="text-xs sm:text-sm break-words text-gray-600">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white border border-gray-200 rounded-lg w-full overflow-x-hidden">
            <div className="px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-200">
              <h3 className="text-sm sm:text-base font-semibold text-gray-900">System Information</h3>
            </div>
            <div className="p-3 sm:p-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 w-full">
                <div className="min-w-0">
                  <p className="text-xs text-gray-500">Status</p>
                  <p className="font-medium text-green-600 text-sm">Online & Bereit</p>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-gray-500">Zugang</p>
                  <p className="font-medium text-blue-600 text-sm">Direkter Zugang</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
